module.exports = __webpack_public_path__ + "img/2.47ef18eb.jpg";